const appSettings = {
    SKALINKAPIURL: import.meta.env.VITE_SKALINKAPI_URL,
    WEBRTCConnectionURL: import.meta.env.VITE_WEBRTC_URL,
    SKALINKContentURL: import.meta.env.VITE_SKALINKCONTENT_URL,
    AuthenticationAuthority: import.meta.env.VITE_AUTH_AUTHORITY,
    AuthenticationRedirectURI: import.meta.env.VITE_AUTH_REDIRECT_URI,
    AuthenticationPostLogoutRedirectURI: import.meta.env.VITE_AUTH_LOGOUT_REDIRECT_URI,
    AuthenticationSilentRedirectURI: import.meta.env.VITE_AUTH_SILENT_REDIRECT_URI,
    ShareScreenConfigurationStun: JSON.parse(import.meta.env.VITE_SHARESCREEN_STUN_JSON),
    ShareScreenConfigurationTurn: JSON.parse(import.meta.env.VITE_SHARESCREEN_TURN_JSON)
};

export default appSettings;
